/* OFF BAPOK — NOIR / EMBER interaction layer: header retreat on scroll,
   scroll reveal, and a quiet synthesised sound set (always on, no toggle).
   Audio is built on the first gesture because browsers block it before one. */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- header retreats on the way down, returns on the way up ---------- */
  var hd = document.querySelector('.ob-hd');
  var last = window.scrollY;
  function onScroll() {
    var y = window.scrollY;
    if (hd) {
      /* a small threshold either way, so a jittery scroll cannot leave the
         header stuck off-screen; near the top it always comes back */
      if (y < 180 || y < last - 4) hd.classList.remove('ob-hd--away');
      else if (y > last + 4) hd.classList.add('ob-hd--away');
    }
    last = y;
    sweep();
  }

  /* The theme reveals [data-reveal] tiles with an observer that sometimes never
     fires — the Kali Puja tile sits at opacity 0 on a live page today. Sweep in
     anything at or above the fold so no block can stay invisible. */
  function sweep() {
    var vh = window.innerHeight;
    var els = document.querySelectorAll('[data-reveal]:not(.in)');
    for (var i = 0; i < els.length; i++) {
      if (els[i].getBoundingClientRect().top < vh * 0.96) els[i].classList.add('in');
    }
  }

  /* ---------- sound: synthesised, quiet, on by default ---------- */
  var ac = null;
  function ctx() {
    if (ac) return ac;
    var C = window.AudioContext || window.webkitAudioContext;
    if (!C) return null;
    try { ac = new C(); } catch (e) { return null; }
    return ac;
  }
  function tone(freq, to, dur, peak, type) {
    var a = ctx();
    if (!a) return;
    if (a.state === 'suspended') a.resume();
    var t = a.currentTime;
    var o = a.createOscillator(), g = a.createGain();
    o.type = type || 'sine';
    o.frequency.setValueAtTime(freq, t);
    if (to && to !== freq) o.frequency.exponentialRampToValueAtTime(to, t + dur);
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(peak, t + 0.008);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.connect(g); g.connect(a.destination);
    o.start(t); o.stop(t + dur + 0.02);
  }
  var tick = function () { tone(2300, 2000, 0.03, 0.012, 'sine'); };
  var tap = function () { tone(760, 420, 0.07, 0.045, 'triangle'); };
  var chime = function () { tone(680, 680, 0.1, 0.05, 'sine'); setTimeout(function () { tone(1020, 1020, 0.14, 0.04, 'sine'); }, 95); };

  var TAP = 'a, button, [role="button"], .chip, .og-chip, summary, .ic, .bagpill';
  var CONFIRM = '.add-to-cart-button, .ob-buynow, [type="submit"]';
  document.addEventListener('pointerdown', function (e) {
    var t = e.target.closest ? e.target.closest(TAP) : null;
    if (!t || t.disabled) return;
    if (t.closest(CONFIRM)) chime(); else tap();
  }, { passive: true });

  /* a breath of a tick when a tile comes under the cursor — pointer devices only */
  if (window.matchMedia && matchMedia('(hover: hover)').matches) {
    var lastTick = 0;
    document.addEventListener('pointerover', function (e) {
      var t = e.target.closest ? e.target.closest('.og-t, .arch, .ac, .pc') : null;
      if (!t) return;
      var now = Date.now();
      if (now - lastTick < 140) return;
      lastTick = now;
      tick();
    }, { passive: true });
  }

  /* ---------- start ---------- */
  function start() {
    if (!reduce) window.addEventListener('scroll', onScroll, { passive: true });
    sweep();
    window.addEventListener('resize', sweep, { passive: true });
    setTimeout(sweep, 1200);
    setTimeout(sweep, 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
